import DataTable from 'components/datatable';
import Error from 'components/Error';
import SelectionUndoneInfo from 'components/SelectionUndoneInfo';
import Spinner from 'components/Spinner';
import WizardActions from 'components/WizardActions';
import PropTypes from 'prop-types';
import React from 'react';
import { Badge, Box } from 'rebass';
import Search from '../search';
import styled from 'styled-components';

const PvBadgeHighlight = styled(Badge)`
  transition: background-color .5s ease;
  background-color: ${props => {
  if (!!props.highlight && props.highlight === 'undone')
    return props.theme.colors.berryRed;
  if (!!props.highlight && props.highlight === 'complete')
    return props.theme.colors.green;
  }};
`;

class Applicants extends React.Component {
  updateApplicantFilters = (applicantFilters) => {
    const newApplicantFilters = Object.assign(this.state.filters, applicantFilters);
    this.setState({filters: newApplicantFilters});
  };

  highlightLessons = (lessons) => {
    this.setState({highlight: lessons});
  };

  constructor(props) {
    super(props);
    this.state = {
      filters: {
        team: '',
        name: '',
        onlyUndone: false,
        selectedLessons: props.selectedLessons,
      },
      highlight: {},
    };
  }

  render() {
    const {
      error,
      applicants,
      selectedLessons,
      loadingApplicants,
      loadingSaving,
      searchType,
      previousFn,
      nextFn,
      currentCourse
    } = this.props;

    const {
      filters,
      highlight
    } = this.state;

    const selectedApplicantsCount = (!!applicants && applicants.filter(a => a.selected).length) || 0;
    const undoneApplicantsCount = (!!applicants && applicants.filter(a => a.undone).length) || 0;
    const payloadApplicants = !!applicants && applicants.filter(a => a.selected || a.undone);

    const infoComponent = <SelectionUndoneInfo
      selectedCount={selectedApplicantsCount}
      undoneCount={undoneApplicantsCount}
    />;

    return (
      <div>
        <Search searchType={searchType}
                updateApplicantFilters={this.updateApplicantFilters}
                filters={filters}
                currentCourse={currentCourse} />
        {loadingApplicants && !error && <Spinner />}
        {error && !loadingApplicants && <Error message={error.message} />}
        <Box mb={2}>
          {selectedLessons
            .sort((a, b) => a.description > b.description)
            .map(l => <PvBadgeHighlight highlight={highlight[l.entityId]} mb={1} key={l.entityId}
                             bg='grays.0'>{l.description}</PvBadgeHighlight>)}
        </Box>
        {!!applicants && !loadingApplicants && !error &&
          <DataTable tableType='THEORY_APPLICANTS' rows={applicants} rowKey='trafiId' filters={filters}
            highlightFn={this.highlightLessons} currentCourse={currentCourse} />
        }
        <WizardActions
          nextText='action.mark_lessons'
          nextFn={() => nextFn({course: currentCourse, applicants: payloadApplicants, lessons: selectedLessons})}
          nextDisabled={selectedApplicantsCount + undoneApplicantsCount === 0}
          loading={loadingSaving}
          previousFn={previousFn}
          additionalComponent={infoComponent} />
      </div>
    );
  }
}


Applicants.propTypes = {
  applicants: PropTypes.array,
  nextFn: PropTypes.func,
  previousFn: PropTypes.func,
  error: PropTypes.object,
  filters: PropTypes.object,
  currentCourse: PropTypes.object,
  loading: PropTypes.bool,
  loadingSaving: PropTypes.bool,
  searchType: PropTypes.string,
  updateApplicantFilters: PropTypes.func,
};

export default Applicants;


// WEBPACK FOOTER //
// ./src/containers/theory/Applicants.jsx